/**
 * Pestañas de Caja & bancos y presets de Cierre diario (F6).
 * Histórico es hermano de Movimientos / Cierre diario; nunca es la home (ESC).
 */
import { addDaysYmd } from "./cierreFechaSiguiente";

export type CajaBancosTab = "movimientos" | "cierre" | "historico";

export const CIERRE_DATE_PRESETS = [
  { value: "hoy", label: "Hoy" },
  { value: "esta-semana", label: "Esta Semana" },
  { value: "este-mes", label: "Este Mes" },
] as const;

export type CierreDatePreset = (typeof CIERRE_DATE_PRESETS)[number]["value"];

export const CIERRE_DATE_PRESET_DEFAULT: CierreDatePreset = "hoy";

export function isCierreDatePreset(value: string): value is CierreDatePreset {
  return CIERRE_DATE_PRESETS.some((p) => p.value === value);
}

/** Primera pestaña operativa. Histórico no entra: ESC vuelve acá. */
export function cajaHomeTab(opts: {
  canMovimientos: boolean;
  canCierre: boolean;
}): CajaBancosTab {
  if (opts.canMovimientos) return "movimientos";
  if (opts.canCierre) return "cierre";
  return "movimientos";
}

export function cajaVisibleTabs(opts: {
  canMovimientos: boolean;
  canCierre: boolean;
}): CajaBancosTab[] {
  const tabs: CajaBancosTab[] = [];
  if (opts.canMovimientos) tabs.push("movimientos");
  if (opts.canCierre) tabs.push("cierre");
  if (opts.canMovimientos || opts.canCierre) tabs.push("historico");
  return tabs;
}

export function cajaTabsGridClass(tabCount: number): string {
  if (tabCount <= 1) return "grid-cols-1";
  if (tabCount === 2) return "grid-cols-2";
  return "grid-cols-3";
}

/**
 * Recorte operativo de Cierre diario.
 * Un valor desconocido (p. ej. el viejo «todos») cae a hoy, no a «sin fecha».
 */
export function cierreMatchesDatePreset(
  cierreYmd: string,
  preset: string,
  todayYmd: string,
): boolean {
  if (!cierreYmd) return false;
  const key = isCierreDatePreset(preset) ? preset : CIERRE_DATE_PRESET_DEFAULT;
  if (key === "hoy") return cierreYmd === todayYmd;
  if (key === "esta-semana") {
    const weekAgoYmd = addDaysYmd(todayYmd, -7);
    return cierreYmd >= weekAgoYmd && cierreYmd <= todayYmd;
  }
  return cierreYmd.slice(0, 7) === todayYmd.slice(0, 7);
}
